// The builder on a narrow screen, as the dashboard creator and the landing
// page's result card lay it out below 900px (NARROW_QUERY). From 900px the
// preview sits in a sticky side rail and the finish bar is a card under the
// design options; below it there is one column, and two strips frame the
// options while the person styles the code:
//
// - PINNED_PREVIEW: the code, pinned to the top. A white strip with a hairline
//   below, no card around it, so the code is the one thing in it. LivePreview
//   `pinned` caps the code at about a quarter of the screen's height.
// - FINISH_DRAWER: the finish bar, docked to the bottom as a drawer. One row,
//   the note small, the button compact.
//
// The strip pins only inside a box that holds it and the design options, and
// the drawer comes after that box. So where the options end, the drawer
// pushes the strip off the screen; it never slides over it.
//
// BLEED_* pull both strips out to the edges of the card the builder sits in
// (the dashboard's p-6, the landing section's p-6 sm:p-8).
export const NARROW_QUERY = "(max-width: 899px)"

export const PINNED_PREVIEW =
  "sticky top-0 z-20 py-2 bg-white dark:bg-midnight border-b border-[color:var(--color-border)] dark:border-storm"

export const FINISH_DRAWER =
  "flex flex-nowrap items-center justify-between gap-3 bg-white dark:bg-midnight " +
  "rounded-t-2xl border-t border-[color:var(--color-border)] dark:border-storm " +
  "pt-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))] shadow-[0_-6px_18px_-10px_rgba(17,17,17,0.35)]"

export const BLEED_DASHBOARD = "-mx-6 px-6"
export const BLEED_HERO = "-mx-6 px-6 sm:-mx-8 sm:px-8"

// The link, notes and downloads: a card of their own after the drawer.
export const RAIL_REST =
  "w-full rounded-lg border border-[color:var(--color-border)] dark:border-storm bg-cloud dark:bg-coal p-4"
